define(function (require) {
	let S4 = function () {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	};
	return {
		formatId: function (description, type) {
			var withHtmlStr = description.match("<span>(.*?)</span>");

			if (withHtmlStr != null)
				description = withHtmlStr[1];

			var combinedStr = description + ' ' + type;
			return combinedStr.replace(/[^a-zA-Z0-9 ]/g, "").split(/\s{1,}/g).join('_');
		},
		S4: function () {
			return S4();
		},
		generateId: function () {
			return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
		}
	}
});